import React, { useEffect, useState } from "react";
import "./Print.module.css";
import styles from "./NewPrint.module.css";
import { useSelector } from "react-redux";
import { AppState } from "../../store";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { BsPersonCircle } from "react-icons/bs";
import { IoAirplane } from "react-icons/io5";
import LogoTicket from "../../../assets/images/airtiketa-logo.png";
import ConfigurationServices from "../../services/configuration.services";
import SwissFlag from "../../../assets/images/swiss.png";
import GermanyFlag from "../../../assets/images/germany.jpg";
import KosovaFlag from "../../../assets/images/kosova.png";

type iProps = {
    reservation: any;
};

const NewPrintInvoice = React.forwardRef(({ reservation }: iProps, ref: any) => {
    const travelers = reservation.travelers.filter((t: any) => t.status);

    // Always use first traveler for outbound flight
    const traveler = travelers[0];

    // NEW FIX: Determine if ANY traveler has a return flight
    const hasReturnFlight = travelers.some((t: any) => t.returningFlight);

    // NEW FIX: Select the traveler who actually HAS the return flight
    const returnTraveler = travelers.find((t: any) => t.returningFlight) || null;

    const [initialImageUrl, setInitialImageUrl] = useState("");
    const account = useSelector((state: AppState) => state.account.account.account);

    useEffect(() => {
        ConfigurationServices.getConfigurationLogo()
            .then((response) => {
                setInitialImageUrl(response.logoImageUrl);
            })
            .catch((error) => {
                console.error("Error fetching initial image:", error);
            });
    }, [initialImageUrl]);

    const returnLogoImage = () => {
        return (
            <div className={styles.logoContainer}>
                <img
                    src={initialImageUrl || LogoTicket}
                    alt="Logo"
                    className={styles.logo}
                />
            </div>
        );
    };

    return (
        <div id="printContent" ref={ref} className={styles.main}>
            <div className={styles.flex}>

                {/* Logo */}
                {returnLogoImage()}

                {/* Social Icons */}
                <div className={styles.icons}>
                    <div className={styles.iconFlex}>
                        <FaFacebook style={{ color: "#EC0C31", fontSize: 25, marginRight: 25 }} />
                        <FaInstagram style={{ color: "#EC0C31", fontSize: 25, marginRight: 25 }} />
                        <FontAwesomeIcon icon={faGlobe} size="2xl" style={{ color: "#EC0C31" }} />
                    </div>
                </div>

                {/* Confirmation Code */}
                <div className={styles.accordionRow}>
                    <div className={styles.accordionHeader}>
                        <div className={styles.accordionLabels}>
                            <span style={{ color: "white", fontSize: 18, fontWeight: "bold", paddingRight: 420 }}>
                                Flight confirmation code:
                            </span>
                            <span style={{ color: "white", fontSize: 20, fontWeight: "bold" }}>
                                {reservation.confirmationCode}
                            </span>
                        </div>
                    </div>
                </div>

                {/* Passenger Info Title */}
                <div
                    style={{
                        marginTop: 10,
                        float: "left",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-start",
                        marginLeft: -530
                    }}
                >
                    <BsPersonCircle style={{ color: "#EC0C31", fontSize: 25, marginRight: 10 }} />
                    <span style={{ fontSize: 18 }}>Passenger info</span>
                </div>

                {/* PASSENGER TABLE */}
                <div style={{ marginTop: 10, width: 700 }}>
                    <table style={{ width: 700 }}>
                        <thead>
                            <tr className={styles.title}>
                                <td>Passenger</td>
                                <td>Route</td>
                                <td>Checked-in bag</td>
                                <td>Seat</td>
                            </tr>
                        </thead>
                        <tbody>
                            {travelers.map((trav: any, index: number) => (
                                <tr className={styles.tableRowFields} key={index}>
                                    <td>
                                        {trav.ageCategory === "ADULT"
                                            ? trav.gender === "MALE"
                                                ? "MR"
                                                : "MRS"
                                            : trav.ageCategory === "CHILD"
                                            ? "CHD"
                                            : "INF"}
                                        . {trav.name} {trav.surname}
                                    </td>
                                    <td>
                                        {trav.departureFlight?.departureAirport?.code} -
                                        {trav.departureFlight?.arrivalAirport?.code}

                                        {trav.returningFlight && (
                                            <>
                                                {" / "}
                                                {trav.returningFlight?.departureAirport?.code} -
                                                {trav.returningFlight?.arrivalAirport?.code}
                                            </>
                                        )}
                                    </td>
                                    <td>
                                        {trav.departureFlight?.gepack} kg 
                                    </td>
                                    <td>-</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                {/* FLIGHT DETAILS TITLE */}
                <div
                    style={{
                        marginTop: 10,
                        float: "left",
                        display: "flex",
                        alignItems: "center",
                        marginLeft: -530
                    }}
                >
                    <IoAirplane style={{ color: "#EC0C31", fontSize: 25, marginRight: 10 }} />
                    <span style={{ fontSize: 18 }}>Flight details</span>
                </div>

                {/* OUTBOUND FLIGHT DETAILS */}
                <div className={styles.secondAccordionRow}>
                    <div className={styles.accordionHeader}>
                        <div>
                            <div className={styles.accordionLabels}>
                                <span style={{ fontSize: 17, color: "#EC0C31" }}>GOING OUT</span>
                                <span style={{ fontSize: 17, color: "#EC0C31" }}>
                                    {traveler.departureFlight?.number}
                                </span>
                            </div>

                            <div className={styles.accordionLabels} style={{ borderTop: "1px solid #DEDEDE" }}>
                                <span style={{ paddingRight: 531 }}>Departs from:</span>
                                <span>Arrives to:</span>
                            </div>

                            <div className={styles.accordionLabels}>
                                <span className={styles.leftLabel}>
                                    <b>
                                        {traveler.departureFlight?.departureAirport.name} (
                                        {traveler.departureFlight?.departureAirport.code})
                                    </b>
                                </span>

                                <span className={styles.centerLabel}>
                                    <IoAirplane fontSize={25} color="#EC0C31" />
                                </span>

                                <span className={styles.rightLabel}>
                                    <b>
                                        {traveler.departureFlight?.arrivalAirport.name} (
                                        {traveler.departureFlight?.arrivalAirport.code})
                                    </b>
                                </span>
                            </div>

                            <div className={styles.accordionLabels}>
                                <span style={{ paddingRight: 430 }}>
                                    {traveler.departureFlight?.dateOfDeparture}{" "}
                                    {traveler.departureFlight?.timeOfDeparture}
                                </span>
                                <span>
                                    {traveler.departureFlight?.dateOfArrival}{" "}
                                    {traveler.departureFlight?.timeOfArrival}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* RETURN FLIGHT DETAILS — FULLY FIXED */}

                    {hasReturnFlight && returnTraveler && (
                        <div className={styles.accordionHeader} style={{ marginBottom: 10 }}>
                            <div>
                                <div className={styles.accordionLabels}>
                                    <span style={{ fontSize: 17, color: "#EC0C31" }}>COMING BACK</span>
                                    <span style={{ fontSize: 17, color: "#EC0C31" }}>
                                        {returnTraveler.returningFlight?.number}
                                    </span>
                                </div>

                                <div className={styles.accordionLabels} style={{ borderTop: "1px solid #DEDEDE" }}>
                                    <span style={{ paddingRight: 531 }}>Departs from:</span>
                                    <span>Arrives to:</span>
                                </div>

                                <div className={styles.accordionLabels}>
                                    <span className={styles.leftLabel}>
                                        <b>
                                            {returnTraveler.returningFlight?.departureAirport.name} (
                                            {returnTraveler.returningFlight?.departureAirport.code})
                                        </b>
                                    </span>

                                    <span className={styles.centerLabel}>
                                        <IoAirplane fontSize={25} color="#EC0C31" />
                                    </span>

                                    <span className={styles.rightLabel}>
                                        <b>
                                            {returnTraveler.returningFlight?.arrivalAirport.name} (
                                            {returnTraveler.returningFlight?.arrivalAirport.code})
                                        </b>
                                    </span>
                                </div>

                                <div className={styles.accordionLabels}>
                                    <span style={{ paddingRight: 430 }}>
                                        {returnTraveler.returningFlight?.dateOfDeparture}{" "}
                                        {returnTraveler.returningFlight?.timeOfDeparture}
                                    </span>
                                    <span>
                                        {returnTraveler.returningFlight?.dateOfArrival}{" "}
                                        {returnTraveler.returningFlight?.timeOfArrival}
                                    </span>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {/* CONTACT INFO */}
                <div
                    className={styles.logoContainer}
                    style={{
                        marginTop: 20,
                        fontSize: 18,
                        display: "flex",
                        gap: 20,
                        alignItems: "center"
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <img src={SwissFlag} width={24} height={16} />
                        <span>+41 44 586 36 66</span>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <img src={GermanyFlag} width={24} height={16} />
                        <span>+49 211 38533933</span>
                    </div>

                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <img src={KosovaFlag} width={24} height={16} />
                        <span>+383 48 282 284</span>
                    </div>
                </div>

                <div>
                    <div className={styles.iconFlex} style={{ marginBottom: 10, fontSize: 18 }}>
                        info@airtiketa.eu
                    </div>
                </div>
            </div>
        </div>
    );
});

export default NewPrintInvoice;
